import { Mapping } from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import _groupBy from 'lodash-es/groupBy';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { matchClassrooms, ClassroomMatchInfo } from './matchClassrooms';
import { getMappingItem } from '@teetsh/app/src/containers/Eleves/Import/File/utils/getMappingItem';
import { getFieldFromRow } from '@teetsh/app/src/containers/Eleves/Import/File/utils/getFieldFromRow';
import _sortBy from 'lodash-es/sortBy';
import { guessClassroomDegree } from './guessClassroomDegree';

export function getClassroomsMapping(
  rows: object[],
  mappings: Mapping[] | null,
  classrooms: Classroom[],
): ClassroomMatchInfo[] {
  const idbeMapping = getMappingItem(mappings, 'idbe');
  const classeMapping = getMappingItem(mappings, 'classe');
  const niveauMapping = getMappingItem(mappings, 'niveau');
  const classroomMapping = idbeMapping || classeMapping;
  const rowsGrouppedByClassroom = _groupBy(rows, row => {
    const niveau = niveauMapping
      ? getFieldFromRow(row, niveauMapping)
      : undefined;
    const classroomId = classroomMapping
      ? getFieldFromRow(row, classroomMapping)
      : undefined;
    if (niveau && classroomId) {
      return `${classroomId}|${niveau}`;
    }
    return classroomId || niveau || '';
  });

  const entriesSortedOfGroupedClassrooms = _sortBy(
    Object.entries(rowsGrouppedByClassroom),
    group => {
      const key = group[0];
      const classroomId = key.includes('|') ? key.split('|')[0] : key;
      return (rows || [])
        .map(r => getFieldFromRow(r, classroomMapping))
        .indexOf(classroomId);
    },
  );

  const classroomsInfoFromFile: ClassroomMatchInfo[] =
    entriesSortedOfGroupedClassrooms.map(([key, clRows]) => {
      const [clId, niveau] = key.includes('|')
        ? key.split('|')
        : [key, undefined];
      const classroomDegree =
        niveau || guessClassroomDegree(clRows, niveauMapping);
      if (idbeMapping) {
        return {
          idBe: clId,
          degree: classroomDegree,
          rows: clRows,
        };
      }
      return {
        name: clId,
        degree: classroomDegree,
        rows: clRows,
      };
    });
  return matchClassrooms(classroomsInfoFromFile, classrooms);
}
